/**
 * src/shell/ui/nav.ts — 导航状态（设计稿 §1.4 导航结构）。
 * 深度 ≤2：桌面 → 物件屏 → 详情；所有深屏统一「回到桌前」。
 */

export type ComputerTab = 'projects' | 'ledger' | 'settings'
export type Dept = 'finance' | 'hr' | 'market' | 'project'

export type Screen =
  | { name: 'title' } // S0
  | { name: 'cockpit' } // S1
  | { name: 'computer'; tab: ComputerTab; projectId?: string } // S2（projectId = 项目详情）
  | { name: 'decisions'; decisionId?: string } // S3
  | { name: 'phone'; dept?: Dept } // S4
  | { name: 'shelf'; projectId?: string } // S5
  | { name: 'newProject' } // S6
  | { name: 'review'; projectId: string } // S7

export const DESK: Screen = { name: 'cockpit' }
